export var getIds = id => id ? {
  root: id,
  touchable: "".concat(id, "__touchable"),
  avatarWrapper: "".concat(id, "__avatar-wrapper"),
  iconWrapper: "".concat(id, "__icon-wrapper"),
  label: "".concat(id, "__label"),
  header: "".concat(id, "__header"),
  title: "".concat(id, "__title"),
  inlineContentWrapper: "".concat(id, "__inline-content-wrapper"),
  inlineContentTitle: "".concat(id, "__inline-content-title"),
  linkWrapper: "".concat(id, "__link-wrapper"),
  linkParagraph: "".concat(id, "__link-paragraph"),
  link: "".concat(id, "__link"),
  contentWrapper: "".concat(id, "__content-wrapper"),
  acceptanceMarkWrapper: "".concat(id, "__acceptance-mark-wrapper"),
  contentParagraph: "".concat(id, "__content-paragraph"),
  asideWrapper: "".concat(id, "__aside-wrapper"),
  line: index => "".concat(id, "__line__").concat(index)
} : {
  line: () => undefined
};
//# sourceMappingURL=getIds.js.map